import { Component } from '@angular/core';

@Component({
    selector: 'mhv-root',
    templateUrl: './root-container.component.html'
})
export class RootContainerComponent {}
